"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCloseModal = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var useCloseModal = function useCloseModal(id) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var closeModal = function closeModal(e) {
    e.stopPropagation();

    if (!e.target.closest("#".concat(id)) && showModal) {
      document.removeEventListener("click", closeModal, false);
      setShowModal(false);
    }
  };

  (0, _react.useEffect)(function () {
    if (showModal) {
      document.addEventListener("click", closeModal, false);
    }

    return function () {
      document.removeEventListener("click", closeModal, false);
    };
  }, [showModal]);
  return [showModal, setShowModal];
};

exports.useCloseModal = useCloseModal;